import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import AdditionalDetailsSubSection from './AdditionalDetailsSubSection';

const AdditionalDetailsSubSections = ({ collection }) => {
  return (
    <>
      {collection.resources().list().map((resource) => (
        <FDBox key={resource.id()} flex={1}>
          <AdditionalDetailsSubSection resource={resource} />
        </FDBox>
      ))}
    </>
  );
};

AdditionalDetailsSubSections.propTypes = {
  collection: PropTypes.object.isRequired,
};

AdditionalDetailsSubSections.defaultProps = {};

export default AdditionalDetailsSubSections;
